import React, {Component} from 'react';
import PropTypes from "prop-types";
import LoadingSplash from "../globalComponents/LoadingSplash";

class IFrameContainer extends Component {

    static propTypes = {
        src: PropTypes.string.isRequired,
    };

    static defaultProps = {
        id: '',
        classes: '',
        width: '100%',
        height: '450px',
        allowFullScreen: true,
    };

    handleFrameTasks = (e) => {
        if (e.data.from.iframe === "load_products") return false;
    };

    constructor(props) {

        super(props);

        this.state = {};

    }

    componentDidMount() {

        //window.addEventListener("message", this.handleFrameTasks);

    }

    componentWillUnmount() {

        //window.removeEventListener("message", this.handleFrameTasks);

    }

    componentWillReceiveProps(nextProps) {

        //if (this.props !== nextProps) {
            //console.debug('IFrameContainer will receive props!');
        //}

        return false;

    }

    shouldComponentUpdate() {

        return false;

    }

    render() {

        let classes = [this.props.classes].join(' ').trim();

        return (
            <div className="iframeContainer">
                <div className="iframeBox">
                    <iframe
                        id={this.props.id}
                        className={classes}
                        src={this.props.src}
                        allowFullScreen={this.props.allowFullScreen}
                    />
                </div>
            </div>
        );

    }

}

export default IFrameContainer;